module.exports = __webpack_public_path__ + "img/Weapon_296.d642618e.png";